import React, { useRef } from "react";
import { ArrowRight, ArrowLeft } from "@phosphor-icons/react";
import { Link } from "react-router-dom";
import Container from "Components/Container/Container";

// swiper
import { Autoplay, Navigation } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";

const ProductUsed = ({ data }) => {
  const prevRef = useRef(null);
  const nextRef = useRef(null);

  return (
    <section className="normal-section mt-primary ">
      <Container>
        <div className="flex items-center justify-center mb-16 gap-x-6">
          <button
            ref={prevRef}
            className="slider-arrow z-[100] bg-light flex items-center justify-center bg-black text-2xl text-black rounded-full p-1"
          >
            <ArrowLeft />
          </button>
          <h4 className="text-3xl uppercase font-bold text-white ">
            Product Used
          </h4>
          <button
            ref={nextRef}
            className="slider-arrow z-[100] rounded-full flex items-center justify-center bg-black text-2xl text-black bg-light p-1"
          >
            <ArrowRight />
          </button>
        </div>
      </Container>
      <div className="flex items-center gap-x-4 px-6">
        <Swiper
          className=" w-full"
          spaceBetween={14}
          slidesPerView={1}
          slidesPerGroup={1}
          navigation={{
            clickable: true,
            prevEl: prevRef.current,
            nextEl: nextRef.current,
          }}
          onBeforeInit={(swiper) => {
            swiper.params.navigation.prevEl = prevRef.current;
            swiper.params.navigation.nextEl = nextRef.current;
          }}
          breakpoints={{
            768: {
              slidesPerView: 2,
              slidesPerGroup: 2,
            },
            992: {
              slidesPerView: 4,
              slidesPerGroup: 4,
            },
          }}
          modules={[Autoplay, Navigation]}
          speed={1000}
        >
          {data?.map(({ name, image, slug }, index) => (
            <SwiperSlide key={index}>
              <Link
                to={`/detailed-product/${slug}`}
                className="flex-1 group  block"
              >
                <div className="overflow-hidden ">
                  <img
                    src={image}
                    alt=""
                    className="max-h-[250px] min-h-[250px] object-contain w-full group-hover:scale-[1.05] transition ease-in duration-300 "
                  />
                </div>
                <p className="text-white mt-2">{name}</p>
              </Link>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
};

export default ProductUsed;
